import { Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
// @src imports
import { DefaultError, Icon } from 'src/chrome'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'
import { getGifts } from 'src/graphql'
import { useQueries } from 'src/hooks'

import styles from '../GiftRibbon/giftRibbon.module.scss'

interface Props {
  giftsQuery: ReturnType<typeof getGifts>
  onClick?: () => void
}

const MoreIcon: React.FC<Props> = props => {
  const { giftsQuery, onClick } = props

  const [gifts] = useQueries(giftsQuery)

  if (!gifts.length) return null

  return (
    <div className={styles.more} onClick={() => onClick?.()}>
      <Text type="body" color="primaryHeading">
        SEE ALL
      </Text>
      <Icon icon={'CARROTRIGHT'} size={12} color={''} />
    </div>
  )
}

export default suspenseBoundary({
  component: MoreIcon,
  unresolved: <></>,
  failure: DefaultError,
})
